import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { userActions } from '../../store/user-slice';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import styles from '../../App.module.css';
import { reviewerLogin } from '../../lib/api';

const LoginDb = () => {

  const history = useNavigate();
  const dispatch = useDispatch();
  const [ email, setEmail ] = useState( '' );
  const [ pw, setPw ] = useState( '' );
  const [ loginFailed, setLoginFailed ] = useState( false );

  const logIn = async (e) => {
  
    e.preventDefault();
    try {
      const body = {
          email: email,
          password: pw
      };

      const response = await reviewerLogin(body);
      console.log(response);
      if (response) {
        // Auth user, set user slice to their stuff
        dispatch( userActions.setIsLoggedIn( response.id ) );
        dispatch( userActions.setIsReviewer( true ) );
        history( '/rnd1review', { replace: true } );
      }
      setLoginFailed(true);
      return response;
    }
    catch (err) {
      console.error(err.message);
    }
  };

  return(
    <Card className={styles['Card']}>
      <h2>Login</h2>
      <Form onSubmit={logIn}>
        <Form.Group as={Card} body className={[styles['CardLvl2'], styles['bl']]}>
          {loginFailed && <p className={styles['unauth']}>Login credentials not recognized, try again</p>}
          <Form.Label as={Card.Title}>
            Email:
          </Form.Label>
          <Form.Control
            required
            type="email"
            value={email}
            onChange={e => setEmail( e.target.value )}
          />
          <Form.Label as={Card.Title}>
            Password:
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={pw}
            onChange={e => setPw( e.target.value )}
          />
        </Form.Group>
        <Card.Body className={styles['flex-wrapper-between']}>
          <Button type="submit" className={styles['btn-round']} variant="secondary">Submit</Button>
        </Card.Body>
      </Form>
    </Card>
  );
};


export default LoginDb;